<template>
	<content-page>
		<template v-slot:content>
			<render-content id="support"></render-content>
		</template>
	</content-page>
</template>

<script>
import RenderContent from "@c/ui/RenderContent";
import ContentPage from "@c/ui/ContentPage";
export default {
	name: "Support",
	components: {
		RenderContent,
		ContentPage,
	},
};
</script>
